import { PaginationComponent } from '../../common';
import { useDispatch, useSelector } from 'react-redux';
import { setPage, selectPagination } from 'ducks/boUsers';
import React from 'react';

export const Pagination = (props: unknown) => {
    const dispatch = useDispatch();

    const pagination = useSelector(selectPagination);

    const handleSetPage = (page: number) => {
        dispatch(setPage({ page }));
    };
    return (
        <PaginationComponent
            {...props}
            pagination={pagination}
            setPage={handleSetPage}
        />
    );
};
